import React, { Component } from 'react'
import './styles.scss'
import PropTypes from 'prop-types'

class Pill extends Component {
  render () {
    return (
      <div
        className={'Pill Pill-' + this.props.type + (this.props.hidden ? ' Pill-Hidden' : '')}
        onClick={this.props.onClick}>{this.props.children}</div>
    )
  }
}

Pill.defaultProps = {
  type: 'default'
}
Pill.propTypes = {
  type: PropTypes.oneOf([
    'blue',
    'green',
    'blackopac',
    'darkblue',
    'darkblue-selected',
    'default'
  ]),
  hidden: PropTypes.bool,
  onClick: PropTypes.func
}
export default Pill
